import { ActivityIndicator, StyleSheet, View } from 'react-native'
import { Button } from '../../../../../../components/Button'
import { DeleteIcon, SendIcon } from '../../../../../../components/Svg'

interface Props {
  onDelete: () => void
  onSend: () => void
  isLoading: boolean
}

export const ActionsButtons = ({ isLoading, onDelete, onSend }: Props) => {
  return (
    <View style={styles.container}>
      <Button label='Eliminar' onPress={onDelete} variant='white'>
        <DeleteIcon height={16} width={17} />
      </Button>
      <Button label='Enviar' onPress={onSend} customStyle={styles.sendBtn} disabled={isLoading}>
        {isLoading ? <ActivityIndicator /> : <SendIcon height={16} width={17} />}
      </Button>
    </View>
  )
}

const styles = StyleSheet.create({
  container: { flexDirection: 'row', paddingBottom: 8, justifyContent: 'center', gap: 24 },
  sendBtn: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    justifyContent: 'center',
    marginLeft: 0,
    marginRight: 0,
  },
})
